import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/filesharing.tsx
var Filesharing = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M16 19.5H19C20.1046 19.5 21 18.6046 21 17.5V9.5C21 8.39543 20.1046 7.5 19 7.5H12.5352C12.2008 7.5 11.8886 7.3329 11.7031 7.0547L10.5937 5.3906C10.2228 4.8342 9.59834 4.5 8.92963 4.5H5C3.89543 4.5 3 5.39543 3 6.5V17.5C3 18.6046 3.89543 19.5 5 19.5H8M12 19.5V13.5M12 13.5L14.5 16M12 13.5L9.5 16",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M2 6.25C2 4.73122 3.23122 3.5 4.75 3.5H8.92963C9.8491 3.5 10.7077 3.95953 11.2178 4.72457L12.3272 6.38867C12.3735 6.45822 12.4516 6.5 12.5352 6.5H19.25C20.7688 6.5 22 7.73122 22 9.25V17.75C22 19.2688 20.7688 20.5 19.25 20.5H12.75V15.3107L13.9697 16.5303C14.2626 16.8232 14.7374 16.8232 15.0303 16.5303C15.3232 16.2374 15.3232 15.7626 15.0303 15.4697L12.5303 12.9697C12.2374 12.6768 11.7626 12.6768 11.4697 12.9697L8.96967 15.4697C8.67678 15.7626 8.67678 16.2374 8.96967 16.5303C9.26256 16.8232 9.73744 16.8232 10.0303 16.5303L11.25 15.3107V20.5H4.75C3.23122 20.5 2 19.2688 2 17.75V6.25Z",
		fill: "currentColor"
	})
});
//#endregion
export { Filesharing };
